import type {
  ICreateDownloadReport,
  IDownloadReportItem,
  IGetDownloadReportListParams,
  IGetDownloadReportListResponse,
} from 'core/model/interfaces/downloads-uploads';
import { formatDateTimeToIso, formatLocaleDate, formatLocaleTime } from 'shared/utils/date.utils';
import type {
  ICreateDownloadReportDTO,
  IDownloadReportItemDTO,
  IGetDownloadReportListParamsDTO,
  IGetDownloadReportListResponseDTO,
} from './downloads.dto';

export const toGetDownloadReportListParams = (
  params: IGetDownloadReportListParams,
): IGetDownloadReportListParamsDTO => {
  const dto: IGetDownloadReportListParamsDTO = {
    fileExportTypeId: params.reportType,
    page: params.page,
    itemsPerPage: params.itemsPerPage,
  };

  return dto;
};

export const toDownloadReportItem = (report: IDownloadReportItemDTO): IDownloadReportItem => {
  const value: IDownloadReportItem = {
    id: new Date(report.createdAt).getTime(),
    filename: report.name,
    filePath: report.fileExportPath,
    status: report.status.id,
    date: formatLocaleDate(report.createdAt),
    time: formatLocaleTime(report.createdAt),
  };

  return value;
};

export const toDownloadReportList = (response: IGetDownloadReportListResponseDTO): IGetDownloadReportListResponse => {
  const list = response.fileExports.map(toDownloadReportItem);

  const result: IGetDownloadReportListResponse = {
    pagination: response.pagination,
    reports: list,
  };

  return result;
};

export const toCreateDownloadReportParams = (params: ICreateDownloadReport): ICreateDownloadReportDTO => {
  const value = {
    fileExportTypeId: params.reportType,
    channelIds: params.channelIds.map(Number),
    name: params.name,
  } as ICreateDownloadReportDTO;

  const { startDate, startTime, endDate, endTime } = params;

  /**
   * As business rule defines, the date range is optional (for Report type: USER_MASTER),
   * so we include it in the request only when both dates are provided.
   */
  const shouldIncludeDateRange = Boolean(startDate && endDate);

  if (shouldIncludeDateRange) {
    const startDateTime = formatDateTimeToIso(startDate as Date, startTime);

    const endDateTime = formatDateTimeToIso(endDate as Date, endTime);

    value.startDatetime = startDateTime;

    value.endDatetime = endDateTime;
  }

  return value;
};
